'use client';
// import useSegmentAnalytics from '@/features/SegmentAnalytics/useSegmentAnalytics';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import ds from '@/styles/ds/ds.module.scss';
import { useSideNavOpen } from '@/store';
import { useGetCurrencies } from '@/backend/common/get-currencies';
import Decimal from 'decimal.js';

export default function BuyEveryCTA() {
	const { getCurrencies, data: currencies } = useGetCurrencies();
	const [everyPrice, setEveryPrice] = useState(0);
	// const { segmentEvents } = useSegmentAnalytics();
	const sideNavOpen = useSideNavOpen();
	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	useEffect(() => {
		if (currencies) {
			//find code code: 'EVERY',
			const every = currencies.find((currency) => currency.code === 'EVERY');
			if (every) {
				const eurPrice = new Decimal(1).dividedBy(
					new Decimal(every.exchangeRate)
				);
				const formattedPrice =
					Math.floor(eurPrice.toNumber() * 100000) / 100000;

				setEveryPrice(formattedPrice);
			}
		}
	}, [currencies]);
	useEffect(() => {
		getCurrencies();
	}, []);

	return (
		<div className="flex flex-col gap-2.5  px-2.5">
			<div className=" flex items-center gap-2">
				<div className="relative w-[42px] h-[42px]">
					<Image
						src="https://cdn.otherworld.xyz/public/assets/coin/everyTokenInfo.webp"
						alt="EVERY"
						className="object-contain w-full h-full"
						fill
						sizes="100%"
					/>
				</div>

				<div className="flex flex-col ">
					<p>
						Everyworld <span className=" text-dove-white-o-70">(EVERY)</span>
					</p>
					<p className="flex text-xs items-center gap-1 ">
						<span className="">
							{everyPrice.toLocaleString('en-US', {
								style: 'currency',
								currency: 'EUR',
								minimumFractionDigits: 6,
							})}
						</span>
						{/* <span className="flex items-center gap-0.5 text-electric-martha">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="9"
								height="7"
								viewBox="0 0 9 7"
								fill="none"
							>
								<path
									d="M4.06588 0.759712C4.25783 0.423804 4.74217 0.423805 4.93412 0.759712L8.07253 6.25193C8.26301 6.58526 8.02232 7 7.63841 7L1.36159 7C0.977679 7 0.736996 6.58526 0.927469 6.25193L4.06588 0.759712Z"
									fill="currentColor"
								/>
							</svg>
							2.28%
						</span> */}
					</p>
				</div>
			</div>
			{sideNavOpen && isMounted ? (
				<div className="flex gap-2 w-full   ">
					<button
						aria-label="Buy Every"
						onClick={() => {
							window?.open(
								'https://www.gate.io/trade/EVERY_USDT?ref=12312805',
								'_blank',
								'noopener,noreferrer'
							);
							// segmentEvents.navigation.routeToBuyEvery();
						}}
						className={`${ds['tertiary']} !min-[30px] !h-[30px] !text-xs !shadow-none`}
					>
						Buy
					</button>
					{/* <button
						aria-label="Buy Every"
						onClick={() => {
							window?.open(
								'https://www.bybit.com/en/trade/spot/EVERY/USDT',
								'_blank',
								'noopener,noreferrer'
							);
							// segmentEvents.navigation.routeToBuyEvery();
						}}
						className={`${ds['tertiary']} !min-[30px] !text-xs`}
					>
						About
					</button> */}
				</div>
			) : null}
		</div>
	);
}
